import { PropsWithChildren, type ReactNode } from 'react';

import cx from 'classnames';

import Icon from '../Icon';
import InfoCircle from '../Icon/icons/InfoCircle';
import s from './index.module.css';

type TipProps = PropsWithChildren<{
  type: keyof typeof defaultIcons;
  icon?: ReactNode;
  className?: string;
}>;

const defaultIcons = {
  info: InfoCircle,
};

export function Tip(props: TipProps) {
  const { type, icon, children, className } = props;

  return (
    <div className={cx(s.tip, className, s[type])}>
      {icon || <Icon width="18px" height="18px" className={s.icon} component={defaultIcons[type]} />}
      {children}
    </div>
  );
}
